module.exports = __webpack_public_path__ + "static/img/contact-banner.88adeb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact-banner.png
// module id = Va8t
// module chunks = 1